var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1597 15.0011C31.1577 19.9743 27.0848 24 22.0622 24C20.8575 24.0017 19.6644 23.7658 18.5514 23.3058C17.4384 22.8459 16.4276 22.1709 15.5771 21.3199C14.7275 22.1712 13.7174 22.8464 12.6049 23.3064C11.4925 23.7664 10.2997 24.0021 9.09551 24C4.06712 24 0 19.972 0 15.0014C0 10.0282 4.06712 6.00136 9.09551 6.00136C10.4704 6.00136 11.7811 6.30053 12.9476 6.84643V2.59116C12.9476 1.15901 14.1239 0 15.5674 0C17.0179 0 18.1895 1.15901 18.1895 2.59116V15.0011C18.1895 17.1089 19.9344 18.808 22.0618 18.808C24.1892 18.808 25.9143 17.1089 25.9163 15.0011V11.7082C25.9163 10.2792 27.0902 9.11393 28.5387 9.11393C29.9795 9.11393 31.1573 10.2792 31.1573 11.7082L31.1597 15.0011ZM5.24183 15.0011C5.24183 17.1089 6.96808 18.808 9.09551 18.808C11.2237 18.808 12.9476 17.1089 12.9476 15.0011C12.9476 12.8929 11.2237 11.1879 9.09551 11.1879C6.96808 11.1879 5.24183 12.8929 5.24183 15.0011Z",
    fill: "#475BE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c05251d176b013373b66f556c9f73c5c.svg";
export { ForwardRef as ReactComponent };